var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-mypage-container"},[_c('Mypage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }